import React, { FC } from 'react'
import { CaptionSM, TitleMD } from '@/atoms/Text'
import { getCurrentYear } from '@/utils/date-utils'
import { useTranslate } from '@/utils/translate/translate-client'

interface NavigationItem {
  name: string
  onClick: () => void
}

interface FooterNavigationProps {
  siteNavigation: NavigationItem[]
}

export const FooterNavigation: FC<FooterNavigationProps> = ({ siteNavigation }) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="shrink-0 text-white">
      <TitleMD>{t('siteNavigation', 'Site Navigation')}</TitleMD>

      <ul className="mt-2 flex flex-col gap-2 md:mt-3">
        {siteNavigation.map((item) => (
          <li className="cursor-pointer" onClick={() => item.onClick()} key={item.name}>
            <CaptionSM className="underline">{item.name}</CaptionSM>
          </li>
        ))}
      </ul>

      <CaptionSM className="mt-10 block">
        {t('footerGiveawayCopyright', '© {{ currentYear }} Angel, LLC. All rights reserved.', {
          currentYear: getCurrentYear(),
        })}
      </CaptionSM>
    </div>
  )
}
